import { render, staticRenderFns } from "./BookingAdditionalSummary.vue?vue&type=template&id=33feec58&scoped=true&"
import script from "./BookingAdditionalSummary.vue?vue&type=script&lang=js&"
export * from "./BookingAdditionalSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingAdditionalSummary.vue?vue&type=style&index=0&id=33feec58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33feec58",
  null
  
)

export default component.exports